"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));

var _ckeditor5Upload = require("@ckeditor/ckeditor5-upload");

var _uuid = require("uuid");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Amend base64uploadadapter to reject the image if it's too big when drop it into the editor
// So it will has the same behaviour as inserting image through the image button in the toolbar
// base64uploadadapter: node_modules/@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter.js
var Adapter = /*#__PURE__*/function () {
  function Adapter(loader, editor) {
    (0, _classCallCheck2["default"])(this, Adapter);
    this.loader = loader;
    this.editor = editor; // Get maxium inline image size config and inlineImageTooLarge handler from grooveImagePluginConfig

    var _editor$config$get = editor.config.get('grooveImagePluginConfig'),
        EDITOR_MAX_INLINE_IMAGE_SIZE = _editor$config$get.EDITOR_MAX_INLINE_IMAGE_SIZE,
        onInlineImageTooLarge = _editor$config$get.onInlineImageTooLarge;

    this.maxInlineImageSize = EDITOR_MAX_INLINE_IMAGE_SIZE;
    this.onInlineImageTooLarge = onInlineImageTooLarge;
  }

  (0, _createClass2["default"])(Adapter, [{
    key: "upload",
    value: function upload() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var reader = new window.FileReader();
        _this.reader = reader;
        reader.addEventListener('load', function () {
          resolve({
            "default": reader.result
          });
        });
        reader.addEventListener('error', function (err) {
          reject(err);
        });
        reader.addEventListener('abort', function () {
          reject();
        });

        _this.loader.file.then(function (file) {
          if (_this.maxInlineImageSize && file.size > _this.maxInlineImageSize) {
            if (typeof _this.onInlineImageTooLarge === 'function') {
              _this.onInlineImageTooLarge((0, _uuid.v4)(), file);
            }

            reject();
          } else {
            reader.readAsDataURL(file);
          }
        });
      });
    }
  }, {
    key: "abort",
    value: function abort() {
      this.reader.abort();
    }
  }]);
  return Adapter;
}();

var grooveBase64UploadAdapter = /*#__PURE__*/function (_Plugin) {
  (0, _inherits2["default"])(grooveBase64UploadAdapter, _Plugin);

  var _super = _createSuper(grooveBase64UploadAdapter);

  function grooveBase64UploadAdapter() {
    (0, _classCallCheck2["default"])(this, grooveBase64UploadAdapter);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(grooveBase64UploadAdapter, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      this.editor.plugins.get(_ckeditor5Upload.FileRepository).createUploadAdapter = function (loader) {
        return new Adapter(loader, _this2.editor);
      };
    }
  }], [{
    key: "requires",
    get: function get() {
      return [_ckeditor5Upload.FileRepository];
    }
  }, {
    key: "pluginName",
    get: function get() {
      return 'grooveBase64UploadAdapter';
    }
  }]);
  return grooveBase64UploadAdapter;
}(_plugin["default"]);

exports["default"] = grooveBase64UploadAdapter;
//# sourceMappingURL=index.js.map